import { useParams, useLocation } from 'react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import LightBoxGallery from '../../components/LightBoxGallery';
import ReactMarkdown from 'react-markdown';
import useHappyEndings from '../../hooks/useHappyEndingsList';
import Preloader from '../../components/Preloader';
import {
  generateHappyEndingSlug,
  findHappyEndingBySlug,
} from '../../utils/petSlug';

function HappyEndingDetail() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language; // "bs" ili "en"
  const { happyEndingSlug } = useParams();
  const location = useLocation();

  const { data: happyEndingsPosts = [], isLoading, error } = useHappyEndings();

  console.log(
    'HappyEndingDetail - slug:',
    happyEndingSlug,
    'state post:',
    location.state?.post
  );

  // Find happy ending from state first (passed via Link), fallback to slug lookup
  const post = useMemo(() => {
    // First priority: use post from location.state (passed directly via Link)
    if (location.state?.post) {
      console.log('Using post from state:', location.state.post);
      return location.state.post;
    }

    if (!happyEndingSlug) {
      console.log('No slug or state provided');
      return null;
    }

    // Fallback: find by slug
    const bySlug = findHappyEndingBySlug(
      happyEndingSlug,
      happyEndingsPosts,
      lang
    );
    if (bySlug) {
      console.log('Found by slug:', happyEndingSlug, bySlug);
      return bySlug;
    }

    console.log(
      'Not found by slug:',
      happyEndingSlug,
      'Available:',
      happyEndingsPosts.map(p => ({
        id: p._id,
        en: p.title_en,
        bs: p.title_bs,
      }))
    );
    return null;
  }, [happyEndingsPosts, happyEndingSlug, location.state?.post]);

  if (isLoading) {
    return (
      <div className="page" style={{ padding: '50px 0', textAlign: 'center' }}>
        <Preloader />
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="page"
        style={{ padding: '50px 0', textAlign: 'center', color: 'red' }}
      >
        {t('common.error')}
      </div>
    );
  }

  if (!post) {
    return (
      <div id="top">
        <PageHeader
          title={t('happyEndingsPage.title')}
          page={t('happyEndingsPage.page')}
          pageUrl={'happyendings'}
        />
        <div className="page">
          <div className="container">
            <h2>{t('common.pageNotFound')}</h2>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  // Formatiranje datuma
  const months = {
    bs: [
      'Januar',
      'Februar',
      'Mart',
      'April',
      'Maj',
      'Juni',
      'Juli',
      'August',
      'Septembar',
      'Oktobar',
      'Novembar',
      'Decembar',
    ],
    en: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
  };

  const dateObj = new Date(post.date);
  const formattedDate = `${months[lang][dateObj.getMonth()]} ${dateObj.getDate()}, ${dateObj.getFullYear()}`;

  // Dinamični tekstovi
  const title = post[`title_${lang}`] || post.title_en;
  const description = post[`description_${lang}`] || post.description_en;

  return (
    <div id="top">
      <PageHeader
        title={t('happyEndingsPage.title')}
        page={t('happyEndingsPage.page')}
        pageUrl={'happyendings'}
        subPage={title}
      />
      <div className="page">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-xl-9 card blog-card">
              <div className="card-body">
                <h3 className="card-title">{title}</h3>
                <div className="post-info border-irregular2 text-muted">
                  {' ' + formattedDate}
                </div>
                <hr />
                {post.images && post.images.length > 0 && (
                  <LightBoxGallery
                    images={post.images}
                    title={title}
                    showThumbnails={true}
                  />
                )}
                <div className="mt-3">
                  <ReactMarkdown
                    components={{
                      a: ({ node, ...props }) => (
                        <a
                          {...props}
                          target="_blank"
                          rel="noopener noreferrer"
                        />
                      ),
                    }}
                  >
                    {description.split('\n').join('  \n')}
                  </ReactMarkdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HappyEndingDetail;
